import React from 'react';

function UtilityImprovingText () {
    return(
        <div>
            <div className="GuideTextPara">
                <h5>Entry Fragging</h5>
                <p>Position that requires great aim, quick reactions, confidence, map knowledge and strong communication. All characteristics of strong entry fraggers in todays game. Throughout this guide, we will talk about each characteristic that is listed above and break down how you can improve at each one of them to ultimately become a better entry fragger.</p>
            </div>
        </div>
    )
}

export default UtilityImprovingText;